import { capitalize } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from '../../../utils/i18n';

interface Filters {
  location: string | null;
  roomTypes: Array<string>;
}

const formatLocation = (location: string) => {
  return location.split(' ').map(capitalize).join(' ');
};

const useHeader = (filters: Filters) => {
  const { t } = useTranslation('common');

  const header = useMemo(() => {
    if (filters.location === null || filters.location === '') {
      if (filters.roomTypes.length === 1) {
        return {
          title: t('headers.no_location_one_room_type.title', {
            roomType: filters.roomTypes[0],
          }),
          description: t('headers.no_location_one_room_type.description', {
            roomType: filters.roomTypes[0],
          }),
        };
      }

      if (filters.roomTypes.length > 1) {
        return {
          title: t('headers.no_location_many_room_types.title'),
          description: t('headers.no_location_many_room_types.description'),
        };
      }
    }

    if (filters.location) {
      if (filters.roomTypes.length === 1) {
        return {
          title: t('headers.one_location_one_room_type.title', {
            roomType: filters.roomTypes[0],
            location: formatLocation(filters.location),
          }),
          description: t('headers.one_location_one_room_type.description', {
            roomType: filters.roomTypes[0],
            location: formatLocation(filters.location),
          }),
        };
      }

      return {
        title: t('headers.one_location_many_room_types.title', {
          location: formatLocation(filters.location),
        }),
        description: t('headers.one_location_many_room_types.description', {
          location: formatLocation(filters.location),
        }),
      };
    }

    return {
      title: t('headers.no_filters_rooms_search_page.title'),
      description: t('headers.no_filters_rooms_search_page.description'),
    };
  }, [filters.location, filters.roomTypes, t]);

  return header;
};

export default useHeader;
